import { Maybe } from "graphql/jsutils/Maybe";
import { DiscountSource, DiscountTranslation } from "../../generated/graphql";
import { IntlShape } from "@/i18n/i18n-client";

type GetTranslatedDiscountTitleInput = {
  defaultTitle?: string | null;
  translations?: Maybe<Maybe<DiscountTranslation>[]> | undefined;
  currentLocale?: string | null;
  intl?: IntlShape;
};

export function getTranslatedDiscountTitle({
  defaultTitle,
  translations,
  currentLocale,
  intl,
}: GetTranslatedDiscountTitleInput) {
  if (defaultTitle === DiscountSource.CustomDiscount) {
    return intl?.formatMessage({
      defaultMessage: "Custom Discount",
      id: "aUZwAz",
    });
  }
  const translation = translations?.find(
    (translation) => translation?.locale === currentLocale
  );

  if (!translation) {
    return defaultTitle;
  }

  return translation.title;
}
